import { ConvexAuthProvider } from '@convex-dev/auth/react';
import { ConvexReactClient } from 'convex/react';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import React, { Suspense } from 'react';
import { scan } from 'react-scan'; // must be imported before React and React DOM

scan({
  enabled: import.meta.env.DEV,
});

import ReactDOM from 'react-dom/client';
import { Router } from './router';
import './index.css';
import './I18n';
import { ErrorBoundary } from './components/ErrorBoundary';
import { AnalyticsProvider } from './components/AnalyticsProvider';

posthog.init(import.meta.env.VITE_PUBLIC_POSTHOG_KEY, {
  api_host: 'https://eu.i.posthog.com',
  capture_pageview: true,
  capture_pageleave: true,
  autocapture: true,
  capture_performance: true,
  // Enable error tracking
  capture_exceptions: true,
  // Disable in development
  loaded: (posthog) => {
    if (import.meta.env.DEV) {
      posthog.opt_out_capturing();
    }
  },
});

const rootElement = document.getElementById('app');
if (!rootElement) {
  throw new Error('Root element not found');
}

const convex = new ConvexReactClient(import.meta.env.VITE_CONVEX_URL as string);

// Service Worker is automatically registered by VitePWA plugin

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <ConvexAuthProvider client={convex} storageNamespace="sunflare">
      <PostHogProvider
        apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
        options={{
          api_host: 'https://eu.i.posthog.com',
        }}
      >
        <AnalyticsProvider autoAcceptInDev={true}>
          <ErrorBoundary>
            <Suspense fallback="Loading...">
              <Router />
            </Suspense>
          </ErrorBoundary>
        </AnalyticsProvider>
      </PostHogProvider>
    </ConvexAuthProvider>
  </React.StrictMode>
);
